<template>
  <modal name="push-type-select-modal" class="offline-review-modal"
         :width="'60%'"
         :height="'85%'"
         @before-close="handlerBeforeClose"
         @before-open="handlerBeforeOpen"
         @opened="handlerOpened"
  >

    <div class="list-content pa15">
      <div
          class="intro_tab col_6"
          @click="movePage('livingTime')"
          :class="{ active: tab === 'livingTime' }"
      >
        거주시간대
      </div>
      <div
          class="intro_tab col_6"
          @click="movePage('livingCountry')"
          :class="{ active: tab === 'livingCountry' }"
      >
        거주 국가
      </div>
      <div
          class="intro_tab col_6"
          @click="movePage('gender')"
          :class="{ active: tab === 'gender' }"
      >
        성별
      </div>
      <div
          class="intro_tab col_6"
          @click="movePage('nationality')"
          :class="{ active: tab === 'nationality' }"
      >
        국적
      </div>
      <div
          class="intro_tab col_6"
          @click="movePage('learningLanguage')"
          :class="{ active: tab === 'learningLanguage' }"
      >
        학습언어
      </div>
      <div
          class="intro_tab col_6"
          @click="movePage('speakingLanguage')"
          :class="{ active: tab === 'speakingLanguage' }"
      >
        구사가능언어
      </div>
      <set-list-component
          v-if="tab === 'livingTime'"
          :setType="`livingTime`"
          :originData ='originData'
      ></set-list-component>
      <set-list-component
          v-if="tab === 'livingCountry'"
          :setType="`livingCountry`"
          :originData ='originData'
      ></set-list-component>
      <set-list-component
          v-if="tab === 'gender'"
          :setType="`gender`"
          :originData ='originData'
      ></set-list-component>
      <set-list-component
          v-if="tab === 'nationality'"
          :setType="`nationality`"
          :originData ='originData'
      ></set-list-component>
      <set-list-component
          v-if="tab === 'learningLanguage'"
          :setType="`learningLanguage`"
          :originData ='originData'
      ></set-list-component>
      <set-list-component
          v-if="tab === 'speakingLanguage'"
          :setType="`speakingLanguage`"
          :originData ='originData'
      >
      </set-list-component>
      <div class="pa15 text-center btn_wrap">
        <el-button type="save" @click="save">저장</el-button>
        <el-button type="cancel" @click="close">닫기</el-button>
      </div>
    </div>
  </modal>
</template>


<script>
import SetListComponent from "@/components/set/SetListComponent";
import SetGenderLayout from "@/template/set/list/SetGenderLayout.vue";
import util from "@/mixins/util";
import pushValidator from "@/mixins/validators/pushValidator";
import EventBus from "@/utils/event-bus";

export default {
  name: "PushTypeSelectModal",
  mixins: [pushValidator],
  components: {
    SetGenderLayout,
    SetListComponent,
  },
  provide() {
    return{
      pushTypeSetData: this.setData,
    }
  },
  props: {

  },
  data() {
    return {
      tab : "livingTime",
      originData : {},
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    setData(key, value) {
      this[key] = value;
    },
    handlerBeforeOpen(event) {
      if (!util.isEmpty(event.params)) {
        this.originData = event.params;
      }
    },
    handlerOpened() {
    },
    handlerBeforeClose() {
      this.originData = {};
      this.tab = 'livingTime'
    },
    save(){
      let temp = {
        residenceCountry : this.residenceCountry,
        spoken : this.spoken,
        study : this.study,
        time : this.time,
        country : this.country,
        gender : this.gender,
        offTime : this.offTime,
      }
      EventBus.$emit('parentChangeFromModal',temp);
      this.close()
    },
    close(){
      this.residenceCountry = [];
      this.spoken = [];
      this.study = [];
      this.time = [];
      this.country = [];
      this.gender = 0;
      this.$modal.hide('push-type-select-modal');
    },
    movePage(url) {
      this.tab = '';
      this.$nextTick(() => {
        this.tab = url
      })
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>
